<p-toast key="already-exists" position="top-left">
    <ng-template let-message pTemplate="message">
        <div class="flex flex-column gap-2">
            <div class="flex align-items-center gap-2">
                <i class="pi pi-exclamation-triangle"></i>
                <span>Un rapport SST existe déjà pour cette date et cet emplacement</span>
            </div>
            <p-button pRipple label="Voir" icon="pi pi-eye" [routerLink]="['/assurancequalite/rapportjournalier', message.data.rapportSstId]"></p-button>
        </div>
    </ng-template>
</p-toast>

<div class="grid">
    <div class="col-12">
        <h6><i class="pi pi-calendar mr-2"></i>Date du rapport</h6>
        <p-calendar [(ngModel)]="date" appendTo="body" [showButtonBar]="true" [showTime]="false" [locale]="'fr'" [dateFormat]="'dd MM yy'"></p-calendar>
    </div>
    <div class="col-12">
        <h6><i class="pi pi-user mr-2"></i>Employé</h6>
        <div class="p-1"><app-employe-avec-emplacement [employe]="employe"></app-employe-avec-emplacement></div>
    </div>
    <div class="col-12">
        <h6><i class="pi pi-map-marker mr-2"></i>Emplacement</h6>
        <p-dropdown [options]="emplacements" 
                    [(ngModel)]="emplacement" 
                    optionLabel="nom"
                    [filter]="true"
                    filterBy="nom,code"
                    [showClear]="true"
                    placeholder="Sélectionner un emplacement"
                    styleClass="w-full"
                    appendTo="body"
                    autofocus>
            <ng-template pTemplate="selectedItem">
                <div *ngIf="emplacement">
                    {{emplacement.nom}} - {{emplacement.codeProjet?.code}}
                </div>
            </ng-template>
            <ng-template pTemplate="item" let-emp>
                {{emp.nom}} - {{emp.codeProjet?.code}}
            </ng-template>
        </p-dropdown>
    </div>
    <div class="col-12">
        <h6><i class="pi pi-copy mr-2"></i>Copier les valeurs du rapport précédent <i class="pi pi-question-circle" pTooltip="Si vous sélectionnez cette option, le nombre de travailleurs et de jours travaillés sans perte de temps seront copiés du rapport précédent."></i></h6>
        <p-checkbox [(ngModel)]="copierValeurs" [binary]="true"></p-checkbox>
    </div>
    <div class="col-12 flex justify-content-end align-items-end mt-4">
        <button pButton 
                label="Annuler" 
                icon="pi pi-times" 
                class="p-button-text mr-2" 
                (click)="ref.close()"></button>
        <button pButton 
                label="Créer" 
                icon="pi pi-check" 
                [disabled]="!emplacement"
                [loading]="loading"
                (click)="creerRapport()"></button>
    </div>
</div>
